<template>
    <div class="section">
        <b-field label="Filtrar resultados" label-position="on-border">
            <b-select
            v-model="selectedType">
                <option value="">----------</option>
                <option value="C">Contacto regular.</option>
                <option value="L">Interesado en producto.</option>
            </b-select>
            <p class="control">
                <b-button 
                @click="fetchContacts"
                type="is-primary">
                Filtrar
                </b-button>
            </p>
        </b-field>
        <b-table
        class="m-b-30"
        :data="count > 0 ? contacts : []"
        :loading="loading"
        :hoverable="true">
            <template slot-scope="props">
                <b-table-column label="Asunto">
                    <a :href="props.row.getStaffDetailUrl">{{ props.row.title }}</a>
                </b-table-column>
                <b-table-column label="Email">
                    <p>{{props.row.email}}</p>
                </b-table-column>
                <b-table-column label="Telefono">
                    <p>{{props.row.phoneNumber}}</p>
                </b-table-column>
                <b-table-column label="Tipo">
                    <span class="tag" :class="props.row.contactType == 'L' ? 'is-success' : 'is-info'">{{props.row.getContactTypeDisplay}} </span>
                </b-table-column>
                <b-table-column label="Producto">
                    <p>{{props.row.productTitle}}</p>
                </b-table-column>
                <b-table-column label="Creado">
                    <p class="tag is-success">{{ new Date(props.row.timestamp).toLocaleDateString() }}</p>
                </b-table-column>

            </template>
            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="frown"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>

        <div class="m-top-30">
            <b-pagination
                :total="count"
                :per-page="perPage"
                :current.sync="page"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="onPageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
            >
            </b-pagination>
        </div>
    </div>
</template>

<script>
import {getHandler} from "./../../../services/http"
export default {
    props:{
        listUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            contacts:[],
            page:1,
            count:0,
            perPage:24,
            selectedType:""
        }
    },
    methods:{
        async fetchContacts(){
            var url = this.listUrl + `?page=${this.page}`
            if (this.selectedType.length){
                url = url + `&contact_type=${this.selectedType}`
            }
            this.loading = true
            var resp = await getHandler(url, {error:false, success:false})
            this.loading = false
            this.contacts = resp.results
            this.count = resp.count
        },
        onPageChange(page){
            this.page = page
            this.fetchContacts
        }
    },
    created(){
        this.fetchContacts()
    }
}
</script>
